import { Storage } from "../../../Common/lib/storage";
import { useEffect, useState } from "react";
import { useMap } from "react-leaflet";
import L from "leaflet";
import * as togpx from "togpx";
import icon from 'leaflet/dist/images/marker-icon.png';
import iconShadow from 'leaflet/dist/images/marker-shadow.png';
import "leaflet/dist/leaflet.css";
import "leaflet-gpx";
import "leaflet.elevation/dist/Leaflet.Elevation-0.0.2.css";
import "./ExtendElevation";
import waypointMarker from "./wpt_marker.png";

function GPXDisplay(props) {
  const map = useMap();
  const [d3, setD3] = useState(false);
  L.Browser.touch = L.Browser.mobile; // This fixes hovering on the graph in Leaflet.Elevation.
  const [gpxData, setGPXData] = useState(null);

  const maxLat = 90; // Maximum latitude
  const minLat = -90; // Minimum latitude
  const maxLng = Infinity; // Maximum longitude
  const minLng = -Infinity; // Minimum longitude

  // Create a LatLngBounds object to represent the bounding box
  const bounds = L.latLngBounds(
    L.latLng(minLat, minLng), // Southwest corner
    L.latLng(maxLat, maxLng) // Northeast corner
  );

  // Set maximum bounds for the map
  map.setMaxBounds(bounds);

  /**
   * D3 must be added globally as a script element for the plugin to work, so add it and have it removed when the 
   * component unmounts, so we dont have to have it loaded for every page.
   */
  useEffect(() => {
    // Create and add the script element for d3
    const script = document.createElement("script");
    script.src = "http://d3js.org/d3.v3.min.js";
    document.head.appendChild(script);

    script.onload = () => {
      setD3(true);
    }

    // Remove the script when unmounted.
    return () => {
      script.remove();
    };
  }, []);


  /**
   * Retrieves gpx data.
   */
  useEffect(() => {
    const fetchData = async () => {
      const file = await Storage.get(props.file);
      const response = await fetch(file);
      if (response.ok) {
        const data = await response.text();

        // If the file is geojson, convert it to gpx.
        if(props.type.includes("geojson")){
          let convertedData = togpx(JSON.parse(data));
          setGPXData(convertedData)
        }
        else{
          setGPXData(data);
        }
      } else {
        // console.error("Failed to fetch GPX data.");
      }
    };

    fetchData();
  }, [props.file]);

  useEffect(() => {
    if (gpxData && d3) {
      // Create the default icon which will be used when the elevation control adds a marker.
      let DefaultIcon = L.icon({
        iconUrl: icon,
        shadowUrl: iconShadow,
        iconSize: [27, 38],
        iconAnchor: [13, 38]
      });
      L.Marker.prototype.options.icon = DefaultIcon;


      L.tileLayer(
        "https://server.arcgisonline.com/ArcGIS/rest/services/World_Street_Map/MapServer/tile/{z}/{y}/{x}"
      ).addTo(map);

      // Create the elevation control.
      let el = L.control.extendElevation({
        width: 250,
        height: 100,
        position: "bottomleft",
        theme: "steelblue-theme",
        margins: {
            top: 20,
            right: 20,
            bottom: 20,
            left: 60
        },
        useHeightIndicator: false
      });
      
      // Create the gpx layer.
      let gpx = new L.GPX(gpxData, {
        async: true,
        marker_options: {
          iconSize: [27, 27],
          iconAnchor: [13, 27],
          popupAnchor: [0, -20],
          startIconUrl: '',
          endIconUrl: '',
          shadowUrl: '',
            wptIconUrls : {
              '': waypointMarker,
            },
          },
      }).on("addline",function(e){
        el.addData(e.line, gpx);
      }).on("loaded", function (e) {
        // Only add the elevation control layer if the gpx has any elevation.
        if(gpx.get_elevation_min()){
          el.addTo(map);
        }
        else{
          el.remove();
        }
        map.fitBounds(e.target.getBounds());

        props.setVisualizationsLoading(loading => {
          loading[props.index] = true;
          return [...loading];
        });

      }).addTo(map);
    }
  }, [gpxData, map, d3]);

  return null; // You can return null or any other desired component here
}

export default GPXDisplay;
